import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import AddVideo from "../../../containers/admin/videos/models/add-video";
import AddVideoFiels from "../../../containers/admin/videos/models/add-video-fiels";
import SearchBar from "../../../containers/admin/videos/searchbar";
import VideosTable from "../../../containers/admin/videos/table";
import { getAllVideosRequest, fixViewsCountRequest } from "../../../modules/admin-modules/videos/Actions";

const Videos = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userData);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllVideosRequest());
  }, [dispatch]);

  const isSuperAdmin =
    user?.role && Array.isArray(user.role) && user.role[0]?.name === "Super Admin";

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      {isSuperAdmin && (
        <Button
          mx={{ base: 4, md: 8 }}
          mb={4}
          size="sm"
          borderRadius="full"
          border="1px solid"
          borderColor="#D8CEC3"
          bg="rgba(255,255,255,0.9)"
          color="#4A0F1F"
          fontWeight="800"
          _hover={{ bg: "rgba(233, 226, 219, 0.5)" }}
          onClick={() => dispatch(fixViewsCountRequest())}
        >
          Fix views count
        </Button>
      )}
      <VideosTable setAdd={setAdd} setSelectedData={setSelectedData} searchTerm={searchTerm} />
      <AddVideo
        key={`video-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
      <AddVideoFiels isAdd={isAdd} data={selectedData} />
    </Layout>
  );
};

export default Videos;
